export { default } from './TimelineOppositeContent';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/lab/esm/TimelineOppositeContent/index.js
// module id = 899
// module chunks = 2